import { ResourceMapping } from '@ariksa/inventory-core/api';

export const getResourceType = (
  name: string,
  resourceTypes: ResourceMapping[],
  type?: string,
) => {
  return resourceTypes?.find(item => {
    if (type === 'agnostic')
      return (
        item.cloud_agnostic_class === name || item.cloud_native_class === name
      );
    return item.cloud_native_class === name;
  });
};
